// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Preview page styles */
.preview__root {
  flex-direction: column;
  height: fit-content;
}

.video-app {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.preview-video {
  position: relative;
  width: 800px;
  height: 450px;
  background: black;
  border-radius: 14px;
  overflow: hidden;
}
.preview-video > video, .preview-video > canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: none;
}
.preview-video > .preview-video-show {
  display: block;
}

.video-operations-preview > div {
  display: flex;
  padding: 15px 20px;
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: 14px;
}

.join-button {
  color: white;
  background: #008dfa;
  border-radius: 14px;
  font-size: 16px;
  height: 3em;
  width: 24em;
  margin: 2em auto;
  cursor: pointer;
  border: none;
  font-stretch: expanded;
  transition: filter 0.15s ease-out;
}

.join-button:hover {
  filter: brightness(110%);
}

/* The "active" pseudo-class MUST come after "hover" */
.join-button:active {
  filter: brightness(80%);
}

.mic-feedback__very-low svg {
  color: green !important;
  opacity: 0.5 !important;
}

.mic-feedback__low svg {
  color: green !important;
  opacity: 0.6;
}

.mic-feedback__medium svg {
  color: green !important;
  opacity: 0.7;
}

.mic-feedback__high svg {
  color: green !important;
  opacity: 0.8;
}

.mic-feedback__very-high svg {
  color: green !important;
  opacity: 0.9;
}

.mic-feedback__max svg {
  color: green !important;
}

.audio-test-wrap {
  width: 800px;
  margin: 0 auto;
  text-align: left;
}
.audio-test-wrap h3 {
  margin-top: 30px;
}
.audio-test-wrap .speaker-action {
  display: flex;
}
.audio-test-wrap .speaker-action .speaker-btn {
  width: 160px;
  margin-right: 30px;
}
.audio-test-wrap .speaker-action .speaker-list {
  min-width: 300px;
}
.audio-test-wrap .speaker-output {
  margin-top: 30px;
  display: flex;
}
.audio-test-wrap .speaker-output .speaker-label {
  width: 160px;
  margin-right: 30px;
}`, "",{"version":3,"sources":["webpack://./src/feature/preview/preview.scss"],"names":[],"mappings":"AAAA,wBAAA;AAEA;EACE,sBAAA;EACA,mBAAA;AAAF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AACA;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;AAEF;AADE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;AAGJ;AADE;EACE,cAAA;AAGJ;;AACA;EACE,aAAA;EACA,kBAAA;EACA,oCAAA;EACA,mBAAA;AAEF;;AAAA;EACE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;EACA,iCAAA;AAGF;;AAAA;EACE,wBAAA;AAGF;;AAAA,sDAAA;AACA;EACE,uBAAA;AAGF;;AAAA;EACE,uBAAA;EACA,uBAAA;AAGF;;AAAA;EACE,uBAAA;EACA,YAAA;AAGF;;AAAA;EACE,uBAAA;EACA,YAAA;AAGF;;AAAA;EACE,uBAAA;EACA,YAAA;AAGF;;AAAA;EACE,uBAAA;EACA,YAAA;AAGF;;AAAA;EACE,uBAAA;AAGF;;AAAA;EACE,YAAA;EACA,cAAA;EACA,gBAAA;AAGF;AAFE;EACE,gBAAA;AAIJ;AAFE;EACE,aAAA;AAIJ;AAHI;EACE,YAAA;EACA,kBAAA;AAKN;AAHI;EACE,gBAAA;AAKN;AAFE;EACE,gBAAA;EACA,aAAA;AAIJ;AAHI;EACE,YAAA;EACA,kBAAA;AAKN","sourcesContent":["/* Preview page styles */\n\n.preview__root {\n  flex-direction: column;\n  height: fit-content;\n}\n.video-app {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.preview-video {\n  position: relative;\n  width: 800px;\n  height: 450px;\n  background: rgba(0, 0, 0, 1);\n  border-radius: 14px;\n  overflow: hidden;\n  &>video, &>canvas {\n    position: absolute;\n    top:0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: none;\n  }\n  & > .preview-video-show{\n    display: block;\n  }\n}\n\n.video-operations-preview > div{\n  display: flex;\n  padding: 15px 20px;\n  background-color: rgba(0,0,0,0.7);\n  border-radius: 14px;\n}\n.join-button {\n  color: rgba(255, 255, 255, 1);\n  background: rgba(0, 141, 250, 1);\n  border-radius: 14px;\n  font-size: 16px;\n  height: 3em;\n  width: 24em;\n  margin: 2em auto;\n  cursor: pointer;\n  border: none;\n  font-stretch: expanded;\n  transition: filter 0.15s ease-out;\n}\n\n.join-button:hover {\n  filter: brightness(110%);\n}\n\n/* The \"active\" pseudo-class MUST come after \"hover\" */\n.join-button:active {\n  filter: brightness(80%);\n}\n\n.mic-feedback__very-low svg {\n  color: green !important;\n  opacity: 0.5 !important;\n}\n\n.mic-feedback__low svg {\n  color: green !important;\n  opacity: 0.6;\n}\n\n.mic-feedback__medium svg {\n  color: green !important;\n  opacity: 0.7;\n}\n\n.mic-feedback__high svg {\n  color: green !important;\n  opacity: 0.8;\n}\n\n.mic-feedback__very-high svg {\n  color: green !important;\n  opacity: 0.9;\n}\n\n.mic-feedback__max svg {\n  color: green !important;\n}\n\n.audio-test-wrap {\n  width: 800px;\n  margin: 0 auto;\n  text-align: left;\n  h3{\n    margin-top: 30px;\n  }\n  .speaker-action {\n    display: flex;\n    .speaker-btn {\n      width: 160px;\n      margin-right: 30px;\n    }\n    .speaker-list {\n      min-width: 300px;\n    }\n  }\n  .speaker-output {\n    margin-top: 30px;\n    display: flex;\n    .speaker-label {\n      width: 160px;\n      margin-right: 30px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
